export default {"src":"/uk/_next/static/media/icon-passport.e804efc3.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};